<template>
  <v-dialog
    max-width="600"
    persistent
    v-model="showDialog">
    <v-card class="pa-5">

      <v-card-text>
        <v-text-field label="Old Password"></v-text-field>
        <v-text-field label="New Password"></v-text-field>
        <v-text-field label="Confirm New Password"></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          text
          @click="cancelDialog">
          Cancel
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="updatePassword">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['showDialog'],
  data () {
    return {}
  },
  methods: {
    cancelDialog () {
      this.$emit('cancelChangePassword')
    },
    updatePassword () {
    }
  }
}
</script>